// Safe Meta Pixel wrapper that won't crash in sandboxed/iframe environments

const PIXEL_ID = '1461226105653819'

function isPixelLoaded(): boolean {
  return (
    typeof window !== 'undefined' && typeof (window as any).fbq === 'function'
  )
}

function loadPixelScript() {
  try {
    if (typeof window === 'undefined') return
    if ((window as any).fbq) return

    const f = window as any
    const n = (f.fbq = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args)
      } else {
        n.queue.push(args)
      }
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = [] as any[]

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.appendChild(script)
    }
  } catch (e) {
    console.warn('Meta Pixel failed to load:', e)
  }
}

export function initPixel() {
  try {
    loadPixelScript()
    // fbq queue handles calls even before script finishes loading
    if (isPixelLoaded()) {
      ;(window as any).fbq('init', PIXEL_ID)
    }
  } catch (e) {
    console.warn('Meta Pixel init failed:', e)
  }
}

export function trackPageView() {
  try {
    if (isPixelLoaded()) {
      ;(window as any).fbq('track', 'PageView')
    }
  } catch (e) {
    console.warn('Meta Pixel pageView failed:', e)
  }
}

export function trackAddToCart() {
  try {
    if (isPixelLoaded()) {
      ;(window as any).fbq('track', 'AddToCart', {
        value: 4990,
        currency: 'CLP',
        content_name: 'Protocolo de Calma Elite',
        content_type: 'product',
      })
    }
  } catch (e) {
    console.warn('Meta Pixel AddToCart failed:', e)
  }
}
